import { defineComponent as _defineComponent } from 'vue';
import { defineComponent, toRefs } from 'vue';
import { useScreenPlugin } from '@/plugins/vue-screen';
export default /*#__PURE__*/_defineComponent({
  __name: 'CustomTemplateWithLeftBlock',
  props: {
    asideWidth: {
      type: String,
      required: true
    },
    isHeaderStatic: {
      type: Boolean,
      default: false
    },
    maxContentWidth: {
      type: String,
      default: undefined
    },
    menuOffset: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    defineComponent({
      name: 'CustomTemplateWithLeftBlock'
    });
    var _toRefs = toRefs(useScreenPlugin()),
      md = _toRefs.md;
    return {
      __sfc: true,
      md: md
    };
  }
});